import { useEffect } from 'react';
import { GFO_TOKEN } from 'constants';
import { createCookie } from 'utils';
import { useHistory, useParams } from 'react-router';

function GfoEntry() {
  const { token, id } = useParams();
  const history = useHistory();

  useEffect(() => {
    createCookie({
      name: GFO_TOKEN,
      value: token,
      expireTimeInMinutes: 30,
    });
    history.replace(`/place/${id}`);
  }, [token, id, history]);

  return null;
}

export default GfoEntry;
